
<template>
  <div style="position: fixed; top:0; left:0; width: 100%; height: 100%; overflow-y: auto; background: white;">

    <div style="width: 100%; padding: 20px;" v-if="merchant !== false">
      <img style="height: 160px; margin:auto;" :src="merchant.logo"/>
      <div style="text-align: center; margin-top: 20px;">
        {{merchant.title}}
      </div>
      <div v-if="invitation !== false">
        <div style="text-align: center; margin-top: 20px; font-size: 32px;">
          You are invited
        </div>
        <div style="text-align: center; padding: 20px;" v-html="content">

        </div>
        <div style="text-align: center; margin-top: 20px;">
          <span v-if="allowMarketing === true" style="font-size: 22px; color: #2F77E4;" @click="allowMarketing = !allowMarketing"><i class="fas fa-check-square"></i></span>
          <span v-else style="font-size: 22px;" @click="allowMarketing = !allowMarketing"><i class="far fa-square"></i></span>
          <b>{{merchant.title}}</b> will send you offers or news by email unless you object by unchecking this box.
        </div>

        <div style="text-align: center; margin-top: 20px;">
          <button style="border: none; padding: 20px 40px; border-radius: 50px; background: #EF5C29; color: white; line-height: 100%; font-size: 20px;" @click="acceptInvitation">ACCEPT & JOIN</button>
        </div>
        <div style="text-align: center; margin-top: 20px;" v-html="subContent">

        </div>
      </div>
      <div style="width: 100%; padding: 20px;" v-if="newCustomer !== false">
        <div style="text-align: center; margin-top: 20px; font-size: 32px;">
          Thank you for joining!
        </div>
        <div style="text-align: center; margin-top: 20px; font-size: 32px;">
          <button style="border: none; padding: 20px 40px; border-radius: 50px; background: #EF5C29; color: white; line-height: 100%; font-size: 20px;" @click="moveToMyPage">Move to My Page</button>
        </div>
      </div>
      <div style="text-align: center; margin-top: 20px;" v-html="tnc">

      </div>
      <div style="text-align: center; margin-top: 50px;">
        <b>{{merchant.title}}</b>
        <br/>
        {{merchant.address}}
        <br/>
        {{merchant.city}}<br/>{{merchant.postCode}}
      </div>
    </div>
    <div class="page-gif-loader" v-if="merchant === false && dialog === false">
      <UtensilLoader/>
    </div>
    <div class="page-gif-loader" v-if="accepting">
      <UtensilLoader/>
    </div>
    <Transition name="nested">
      <div class="outer" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.6);" v-if="dialog !== false">
        <div class="inner" style="position: absolute; top: 50%; left: 50%; width: calc(100% - 50px); max-width: 400px; max-height: 80%; background: white; padding-top: 0; overflow-y: scroll; transform: translate(-50%, -50%); border-radius: 10px;">
          <div style="width: 100%; height: 300px; background: #f39a49;" v-if="dialog.success === false">
            <img style="height: 100%;" src="https://storage.googleapis.com/menus-275719.appspot.com/icons/smtm/sorry_cat.png"/>
          </div>
          <div style="width: 100%; height: 80px; background: #E84725; color: white; font-weight: bold; font-size: 25px;" v-else-if="dialog.success === true">
            {{dialog.title}}
          </div>
          <div style="width: 100%; padding: 20px; text-align: center;">
            {{dialog.description}}
          </div>
          <div style="width: 100%; padding: 15px; text-align: center;">
            <button style="background: #E84725; border: none; border-radius: 10px; color: white; font-size: 20px; padding: 8px 20px 10px 20px; font-weight: bold;"
                    @click="dialog = false">Close</button>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>
<script>

import { acceptLoyaltyInvitation, getLoyaltyInvitation } from "../api/borium";
import {isLanDevHost, pageHostname} from "../api/hosts";
import UtensilLoader from "./UtensilLoader.vue";

export default {
  name: "LoyaltyInvitation",
  components: { UtensilLoader },
  data() {
    return {
      invitationId:0,
      merchant:false,
      invitation:false,
      inviteePoint: 0,
      tnc:'',
      content:'',
      subContent: '',
      message:'',
      allowMarketing:true,
      newCustomer: false,
      dialog: false,
      accepting: false,
    }
  },
  created() {

  },
  mounted() {
    this.onLoaded()
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    onLoaded: function() {
      if(this.$route.params.invitationId === undefined) {
        return;
      }
      this.$data.invitationId = this.$route.params.invitationId;

      // console.log(this.$data.invitationId);
      // console.log(window.location.host);
      let self = this;
      getLoyaltyInvitation(this.$data.invitationId)
        .then(function(data) {
          if(data.item !== undefined && data.item !== null) {
            self.$data.merchant = data.item.merchant;
            self.$data.invitation = data.item.customer;
            self.$data.inviteePoint = data.item.inviteePoint;
            self.$data.tnc = data.item.tnc;
            self.$data.content = data.item.content;
            self.$data.subContent = data.item.subContent;
          }
          if(data.success === false) {
            self.$data.message = data.message;
            self.$data.dialog = {
              title:'Error',
              description: data.message,
              success:false,
            };
          } else {

          }
        })
    },
    acceptInvitation: function() {

      let self = this;
      this.$data.accepting = true;
      acceptLoyaltyInvitation(this.$data.invitationId, this.$data.allowMarketing)
        .then(function(data) {
          self.$data.accepting = false;
          if(data.success === true) {
            self.$data.invitation = false;
            self.$data.newCustomer = data.item;
          } else {
            self.$data.dialog = {
              title:'Error',
              description: data.message,
              success:false,
            };
          }
        })
        .catch(function(err) {
          console.error('Request failed', err && err.response ? err.response.status : '');
          self.$data.accepting = false;
          self.$data.dialog = {
            title:'Error',
            description:'Something went wrong',
            success:false,
          };
        })
    },
    moveToMyPage: function() {


      localStorage.setItem("loyaltycard_remember", true);
      localStorage.setItem("loyaltycard_email", this.$data.newCustomer.email);

      // console.log(window.location.host);
      let url = 'http';

      let local = false;
      if(!isLanDevHost()) {
        url += 's';
      }
      if(isLanDevHost() || pageHostname() === 'dev.showmethemenu.net') {
        local = true;
      }
      url += '://' + window.location.host +  '/loyalty/register';
      // console.log(this.$data.merchant);
      if(local === true || this.$data.merchant.customDomain === null || this.$data.merchant.customDomain.length === 0) {
        url += '?merchant=' + this.$data.merchant.id;
      }
      window.location.href  = url;

    }
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/LoyaltyInvitation.vue